var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-jumbotron',{attrs:{"header":"Enquesta GdT","lead":"Implementada per lequia"}},[_c('b-button',{attrs:{"to":"/login"}},[_vm._v("Començar")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }